import { connect } from 'react-redux'
import * as actions from '../actions'

// Wrap actions in dispatch
export default connect(
  null,
  actions
)
